import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import { useStyles } from "../../styles";
import { useTranslation } from "react-i18next";
import { CustomPaper } from "../../../../../../../../../../components/CustomPaper";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { icons } from "../../../../../../../../../../utils/icons";
import { useEvidences } from "../../../../../../../../../../hooks/evidences/useEvidences";
import EvidenceDetail from "../../../../../../../../../actionPlans/pages/form/components/evidenceDetail";
import { VIEW_TYPES } from "../../../../types/ViewTypes";
import { SnackSimple } from "../../../../../../../../../../components";
import { Types } from "../../../../../../../../../../utils/enums/types";
import { ActionDrawer } from "../../../../../../../../../../components/ActionDrawer";
import { useEvidenceDownload } from "../../../../../../../../../calendar/pages/detail/hooks";
import { Constants } from "../../../../../../../../../../utils/constants";
import { AnswerTypeHistory } from "../../../../enums/answerType";

export const CuoteResponse = ({ items, onAttend, disabled }) => {
  const styles = useStyles();
  const { t } = useTranslation();
  //const { isDownloading, error, downloadEvidences } = useDownloadEvidences();
  const [alertModals, setAlertModals] = useState(false);
  const [messageAlertModals, setMessageAlertModals] = useState("");
  const lastQuote = items?.filter((item) => item.type === AnswerTypeHistory.QUOTE).at(-1);
  const reasonOfRejectionQuote = lastQuote?.reasonOfRejectionQuote
  const reasonOfApproveQuote = lastQuote?.commentApprovalQuote
  const { evidences, existEvidences } = useEvidences({
    evidencesResponse: lastQuote?.evidencesQuote,
    manualValue: false,
  });
  const isSubmiteed = lastQuote?.quoteSubmitted

  const { disable: isDownloading, /* openSnackbar, handleCloseSnackbar, */ downloadEvidences, } = useEvidenceDownload('evidencias', lastQuote?.evidencesQuote);

  const provider = lastQuote?.userReviewerQuote
    ? `${lastQuote.userReviewerQuote.firstName} ${lastQuote.userReviewerQuote.lastName}`
    : t("reportFolio.detail.general.noAssignedUser");

  const commentUpload = lastQuote?.commentUpload

  const formattedDate = lastQuote?.dateUploadQuote
    ? format(new Date(lastQuote.dateUploadQuote), Constants.dateFormatGeneral3, { locale: es })
    : t("reportFolio.detail.general.noDateAvailable");

  const formatDateRequest = lastQuote?.dateRequestManagement
    ? format(new Date(lastQuote.dateRequestManagement), Constants.dateFormatGeneral3, { locale: es })
    : t("reportFolio.detail.general.noDateAvailable");

  const handleDownloadQuoteZip = async () => {
    setMessageAlertModals("Descargando evidencias...");
    setAlertModals(true);
    try {
      await downloadEvidences(lastQuote?.evidencesQuote, "evidences.zip");
    } catch (error) {
      console.error("Error downloading evidences:", error);
    } finally {
      setAlertModals(false);
    }
  };

  return (
    <>
      <CustomPaper sx={styles.userContainer} elevation={3}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <Box >
              {reasonOfRejectionQuote ? (
                <Box display="flex" alignItems="center">
                  <Typography sx={styles.title(3)}>
                    {icons("cancel")}
                  </Typography>
                  <Typography style={{ marginLeft: '8px' }} sx={styles.title(3)}>
                    {t("reportFolio.detail.general.quotationTitleProviderSendCancel")}
                  </Typography>
                </Box>
              ) : reasonOfApproveQuote ? (
                <Box display="flex" alignItems="center">
                  <Typography sx={styles.title(4)}>
                    {icons("check")}
                  </Typography>
                  <Typography style={{ marginLeft: '8px' }} sx={styles.title(4)}>
                    {t("reportFolio.detail.general.quotationTitleProviderSendApprove")}
                  </Typography>
                </Box>
              ) : (
                <>
                  {isSubmiteed ? (
                    <Box display="flex" alignItems="center">
                      <Typography sx={styles.title(2)}>
                        {icons("info")}
                      </Typography>
                      <Typography style={{ marginLeft: '8px' }} sx={styles.title(2)}>
                        {t("reportFolio.detail.general.quotationProviderSend")}
                      </Typography>
                    </Box>
                  ) : (
                    <Typography sx={styles.title(2)}>
                      {t("reportFolio.detail.general.quotationTitleProvider")}
                    </Typography>
                  )}
                </>
              )}
            </Box>
            {reasonOfRejectionQuote ? (
              <Typography variant="body2">
                {t("reportFolio.detail.general.providerAssignedAndDateAndReject", { Date: formattedDate, Rechazada: formatDateRequest })}
              </Typography>
            ) : reasonOfApproveQuote ? (
              <Typography variant="body2">
                {t("reportFolio.detail.general.providerAssignedAndDateAndApprove", { Date: formattedDate, Rechazada: formatDateRequest })}
              </Typography>
            ) : (
              <Typography variant="body2">
                {t("reportFolio.detail.general.providerAssignedAndDate", { Date: formattedDate })}
              </Typography>
            )
            }

          </Box>

          {reasonOfRejectionQuote || reasonOfApproveQuote || isSubmiteed ? (
            <>
            </>
          ) :
            <Box display="flex" gap={2}>
              <Button variant="contained" disabled={disabled} onClick={() => onAttend(VIEW_TYPES.SEND_SOLUTION)}>
                {t("reportFolio.detail.general.AttendquotationTitle")}
              </Button>
            </Box>
          }
        </Box >

        {reasonOfRejectionQuote ? (
          <Typography variant="body1"
            sx={{
              '&.MuiTypography-root':
                { wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal", }
            }}
          >
            {reasonOfRejectionQuote}
          </Typography>
        ) : reasonOfApproveQuote ? (
          <Typography variant="body1"
            sx={{
              '&.MuiTypography-root':
                { wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal", }
            }}
          >
            {reasonOfApproveQuote}
          </Typography>
        ) : isSubmiteed ? (
          <Box/*  display="flex" alignItems="center" justifyContent="space-between" */>
            <Typography variant="body1"
            sx={{
              '&.MuiTypography-root':
                { wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal", }
            }}
            >
              {t("reportFolio.detail.general.quotationSendInfo")}
            </Typography>
            {commentUpload ? (
              <Typography
                sx={{
                  '&.MuiTypography-root':
                    { wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal", }
                }}
              >
                {commentUpload}
              </Typography>
            ) : <></>}
            <Box display="flex" alignItems="center" justifyContent={'end'} gap={2}>
              <ActionDrawer
                title="EVIDENCIAS"
                body={<>
                  <Box sx={styles.mainContainer}>
                    <Box sx={styles.bodyContainer}>
                      <EvidenceDetail
                        existEvidences={existEvidences}
                        evidences={{
                          image: evidences?.images,
                          comment: evidences?.comments,
                          documents: evidences?.documents,
                          video: evidences?.video,
                          sign: evidences?.sign
                        }}
                      />
                    </Box>
                    <Box>
                      <Button variant='text_primary_small' onClick={downloadEvidences} disabled={isDownloading}>{t('schedule.buttons.downloadEvidence')}</Button>
                    </Box>
                  </Box>
                </>}
              >
                {
                  ({ openDrawer }) =>
                    <Tooltip title={t("ToolTips.seeEvidences")}>
                      <IconButton
                        onClick={() => { openDrawer() }}
                        sx={styles.clip}
                        disabled={!existEvidences}
                      >
                        {icons("clip")}
                      </IconButton>
                    </Tooltip>
                }
              </ActionDrawer>

              {existEvidences &&
                <Button variant="outlined" color="primary" onClick={handleDownloadQuoteZip}>
                  {t("reportFolio.detail.general.dowloadQuote")}
                  <Box ml={1} mt={1}>{icons("download")}</Box>
                </Button>
              }
            </Box>
          </Box>

        ) : (
          <>
          </>
        )}

        {reasonOfRejectionQuote || reasonOfApproveQuote ? (
          <Box display="flex" justifyContent="end" gap={3} alignContent={"center"}>
            <ActionDrawer
              title="EVIDENCIAS"
              body={<>
                <Box sx={styles.mainContainer}>
                  <Box sx={styles.bodyContainer}>
                    <EvidenceDetail
                      existEvidences={existEvidences}
                      evidences={{
                        image: evidences?.images,
                        comment: evidences?.comments,
                        documents: evidences?.documents,
                        video: evidences?.video,
                        sign: evidences?.sign
                      }}
                    />
                  </Box>
                  <Box>
                    <Button variant='text_primary_small' onClick={downloadEvidences} disabled={isDownloading}>{t('schedule.buttons.downloadEvidence')}</Button>
                  </Box>
                </Box>
              </>}
            >
              {
                ({ openDrawer }) =>
                  <Tooltip title={t("ToolTips.seeEvidences")}>
                    <IconButton
                      onClick={() => { openDrawer() }}
                      sx={styles.clip}
                      disabled={!existEvidences}
                    >
                      {icons("clip")}
                    </IconButton>
                  </Tooltip>
              }
            </ActionDrawer>

            <Button variant="outlined" color="primary" onClick={() => onAttend(VIEW_TYPES.DETAIL_QUOTE, lastQuote?.id)}>
              {t("reportFolio.detail.general.seeDetailQuote")}
            </Button>
            <Button variant="outlined" color="primary" onClick={handleDownloadQuoteZip}>
              {t("reportFolio.detail.general.dowloadQuote")}
              <Box ml={1} mt={1}>{icons("download")}</Box>
            </Button>
          </Box>
        ) : (
          <>
          </>
        )}
      </CustomPaper >

      <SnackSimple
        open={alertModals}
        close={() => setAlertModals(false)}
        message={messageAlertModals}
        type={isDownloading ? Types.INFO : Types.SUCCESS}
      />
    </>
  );
};
